import { render, staticRenderFns } from "./category-med.vue?vue&type=template&id=06cddb21"
import script from "./category-med.vue?vue&type=script&lang=js"
export * from "./category-med.vue?vue&type=script&lang=js"
import style0 from "./category-med.vue?vue&type=style&index=0&id=06cddb21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports